import { resourceService } from "../services";

function getDefaultLocale() {
	const DEFAULT_LOCALE = "ua";

	return DEFAULT_LOCALE;
	
	// const navigatorLocale =
	// 	navigator.languages !== undefined
	// 		? navigator.languages[0]
	// 		: navigator.language;

	// if (!navigatorLocale) {
	// 	return DEFAULT_LOCALE;
	// }

	// return navigatorLocale.trim().split(/-|_/)[0];
}

export const localization = {
	namespaced: true,
	state: {
		data: null,
		locale: null
	},
	actions: {
		async initLocale({ commit, state }) {
			try {
				const locale = state.locale ? state.locale : getDefaultLocale();

				const localeResponse = await resourceService.get(`locales/${locale}.json`);

				if (localeResponse.isSuccess) {
					const payload = {
						locale: locale,
						data: localeResponse.data
					};

					commit('localeSuccess', payload);
				}
				else {
					commit('localeFailure');
				}
			}
			catch (error) {
				commit('localeFailure', error);
			}
		},
		async changeLocale({ commit }, locale) {
			try {
				const localeResponse = await resourceService.get(`locales/${locale}.json`);

				if (localeResponse.isSuccess) {
					const payload = {
						locale: locale,
						data: localeResponse.data
					};

					commit('localeSuccess', payload);
				}
				else {
					commit('localeFailure');
				}
			}
			catch (error) {
				commit('localeFailure', error);
			}
		}
	},
	mutations: {
		localeSuccess(state, payload) {
			state.locale = payload.locale;
			state.data = payload.data;
		},
		localeFailure(state) {
			state.locale = null;
			state.data = null;
		}
	}
}
